import React, { useRef } from 'react';
import {
  useRefresh,
  TextField,
  NumberField,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
} from 'react-admin';

import { Card } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoProduto2 } from '../../Components';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_FAMILIAS_LISTAR } from '../../utils/dadosTelas';
import Actions from './ActionsList2';
import DialogoCriarEditar from './DialogoCreateEdit';
import DialogoDeletar from './DialogoDeletar';
import Filter from './Filter';

const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogo = useRef(null);
  const refDialogoProduto = useRef(null);
  const refDialogoDeletar = useRef(null);

  const create = (tipo) => {
    if (refDialogo.current) {
      refDialogo.current.handleCreate(tipo);
    }
  };

  const edit = (data) => {
    if (refDialogo.current) {
      refDialogo.current.handleEdit(data.id);
    }
  };

  const createProduto = ({ id }) => {
    if (refDialogoProduto.current) {
      refDialogoProduto.current.handleCreateApartirFamilia(id);
    }
  };

  const deletar = (data) => {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(data.id);
    }
  };

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <ListToolbar
        filters={<Filter />}
        actions={<Actions handleCriar={create} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="nome" label="Descrição" />
          <NumberField
            source="preco_venda"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: 'currency',
              currency: 'BRL',
            }}
            label="Preço de Venda"
          />

          <ActionsField
            source="lalala"
            textAlign="right"
            label="Ações"
            sortable={false}
            /* handleEdit={handleEdit}
            handleShow={handleShow} */
            actions={[
              {
                key: 'delete',
                title: 'Excluir',
                icon: <DeleteOutlineIcon />,
                onClick: deletar,
              },
              {
                key: 'add',
                title: 'Novo Produto',
                icon: <AddIcon />,
                onClick: createProduto,
              },
              {
                key: 'editar',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (rec) => edit(rec),
                show: () => true,
                disabled: () => false,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoCriarEditar ref={refDialogo} handleClose={handleClose} />
      <DialogoProduto2 ref={refDialogoProduto} handleClose={handleClose} />
      <DialogoDeletar ref={refDialogoDeletar} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ ...props }) => (
  <ListBase {...props}>
    <MyList />
  </ListBase>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const CategoryList = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_FAMILIAS_LISTAR}>
    <ContainerMyList
      {...props}
      title=""
      component="div"
      bulkActionButtons={false}
      sort={{ field: 'nome', order: 'asc' }}
      perPage={20}
      pagination={false}
    />
  </ProtegerPagina>
);

export default CategoryList;
